import React, { FunctionComponent } from 'react'
import { Stepper as StepperComponent } from '@material-ui/core'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import { IStepper } from './StepperComponent.types'
import { useStyles } from './styles'

const Stepper: FunctionComponent<IStepper> = ({ step, data }: IStepper) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <StepperComponent activeStep={step} className={classes.root}>
        {data?.map((label, index) => {
          return (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          )
        })}
      </StepperComponent>
    </div>
  )
}
export default Stepper
